import { BasketAmendItemOptions, BasketResponse, ODMBasketResponse } from 'types/BasketTypes';
import { BasketServiceInterface } from '../interface/BasketServiceInterface';
import adaptBasketResponse from '../adaptors/adaptBasketResponse';

export default class ODMBasketService implements BasketServiceInterface {
  async addItem(): Promise<never> {
    throw new Error('addItem is not implemented for ODMBasketService.');
  }

  async amendItem({ lineItem, item }: BasketAmendItemOptions): Promise<BasketResponse> {
    if (!lineItem || typeof lineItem !== 'string') {
      throw new Error('Line item is required to amend an item in the basket.');
    }

    if (!window.ODM || !window.ODM.basket || typeof window.ODM.basket.amendItem !== 'function') {
      throw new Error('ODM basket service is not available.');
    }

    const response = (await window.ODM.basket.amendItem(lineItem, item)) as ODMBasketResponse;

    return adaptBasketResponse({
      data: response?.data,
      error: response?.error,
      status: response.status,
    });
  }
}
